export const TOGGLE_MODAL = 'modal/TOGGLE_MODAL';
